import { type UseQueryResult, useQuery } from 'react-query';
import { OptionAwardService } from '../../services/wealthlane-award-services';

const useGetOptionAcceptance = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const optionAcceptanceList = useQuery(
    ['getOptionAcceptanceList'],
    async () => {
      return await handleRequest(
        OptionAwardService.getApiAwardApiAppOptionAwardOptionAcceptances()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return optionAcceptanceList;
};

export default useGetOptionAcceptance;
